'use client';
import React from 'react';
import genericLoader from '@/../public/lotties/loaders/generic-loader.json';
import styles from './genericLoader.module.scss';
import dynamic from 'next/dynamic';
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const GenericLoader = () => {
  return (
    <div className={styles['main-con']}>
      <div className={styles['lottie-con']}>
        <Lottie animationData={genericLoader} />
      </div>
    </div>
  );
};

export default GenericLoader;
